"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const LimitSelector_1 = require("./LimitSelector");
const LimitList = ({ device, limits, updateFrequencyLimits, updateActivePopover, }) => (React.createElement(React.Fragment, null, limits
    .filter(({ interval }) => interval && interval.value > 0)
    .map((_, index) => (React.createElement("div", { key: index, onClick: () => updateActivePopover(`limit-selector-edit-popover-${index}`) },
    React.createElement(src_1.List, { separationElement: index > 0 && React.createElement(src_1.Badge, { color: src_1.steel, text: "AND" }) },
        React.createElement(LimitSelector_1.default, { device: device, type: "edit", id: index }),
        React.createElement(src_1.CircleCloseIcon, { fill: src_1.silver, onClick: (e) => {
                e.stopPropagation();
                updateFrequencyLimits(limits.slice(0, index).concat(limits.slice(index + 1)));
            } })))))));
const mapStateToProps = (state) => ({
    limits: reducers_1.getEditableCampaignFrequencyLimits(state),
});
const mapDispatchToProps = (dispatch) => ({
    updateFrequencyLimits: (limits) => dispatch(actions_1.updateFrequencyLimits(limits)),
    updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LimitList);
